const extensionByMimeType: Record<string, string> = {
  "application/pdf": "pdf",
  "image/avif": "avif",
  "image/gif": "gif",
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/svg+xml": "svg",
  "image/webp": "webp",
  "video/mp4": "mp4",
  "video/ogg": "ogv",
  "video/webm": "webm",
};

const getFileName = (src: string, mimeType: string) => {
  try {
    const fileName = new URL(src, window.location.origin).pathname
      .split("/")
      .filter(Boolean)
      .at(-1);
    const decoded = fileName ? decodeURIComponent(fileName) : "";

    if (/\.[a-z0-9]{1,10}$/i.test(decoded)) return decoded;
  } catch {
    // Use the fallback name below when the source URL cannot be parsed.
  }

  const extension = extensionByMimeType[mimeType.toLowerCase()] || "bin";
  return `product-media.${extension}`;
};

export const downloadMediaFile = async (src: string) => {
  if (!src || typeof window === "undefined") {
    throw new Error("Файл недоступен для скачивания");
  }

  const response = await fetch(src, { credentials: "omit" });
  if (!response.ok) {
    throw new Error("Файл недоступен для скачивания");
  }

  const blob = await response.blob();
  const downloadUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = downloadUrl;
  link.download = getFileName(src, blob.type);
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
};
